import { Define } from '../../../core/decorators';
import { TAG_DANGER } from '../../../core/utils/constants/tags';
import { ButtonVariation, HTMLBnumButton } from '../button';
import { Variation } from '../button/bnum-button.internal/decorators';
/**
 * Bouton Bnum de type "Danger".
 *
 * @category Buttons
 *
 * @structure Cas standard
 * <bnum-danger-button>Texte du bouton</bnum-danger-button>
 *
 * @structure Bouton avec icône
 * <bnum-danger-button data-icon="home">Texte du bouton</bnum-danger-button>
 *
 * @structure Bouton avec une icône à gauche
 * <bnum-danger-button data-icon="home" data-icon-pos="left">Texte du bouton</bnum-danger-button>
 *
 * @structure Bouton en état de chargement
 * <bnum-danger-button loading>Texte du bouton</bnum-danger-button>
 *
 * @structure Bouton arrondi
 * <bnum-danger-button rounded>Texte du bouton</bnum-danger-button>
 *
 * @structure Bouton cachant le texte sur les petits layouts
 * <bnum-danger-button data-hide="small" data-icon="menu">Menu</bnum-danger-button>
 */
@Define({ tag: TAG_DANGER })
@Variation(ButtonVariation.DANGER)
export class HTMLBnumDangerButton extends HTMLBnumButton {
	constructor() {
		super();
	}
}
